import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

declare let $;

@Component({
  selector: 'app-database-manager',
  templateUrl: './database-manager.component.html',
  styleUrls: ['./database-manager.component.scss']
})
export class DatabaseManagerComponent implements OnInit {

  @Input() databaseSelected: any;
  @Output() selectedDatabaseOutput = new EventEmitter<{}>();

  availableDatabase = [];

  databaseTypes = [
    {'displayName': 'MongoDB', 'image': './assets/img/partnerOnboarding/mongoDB.png', 'value': 'mongodb'},
    {'displayName': 'DynamoDB', 'image': './assets/img/partnerOnboarding/dynamoDB.png', 'value': 'dynamodb'},
    {'displayName': 'PostgreSQL', 'image': './assets/img/partnerOnboarding/postgreySQL.png', 'value': 'postgresql'},
    {'displayName': 'MySQL', 'image': './assets/img/partnerOnboarding/mySQL.png', 'value': 'mysql'},
    {'displayName': 'MS SQL Server', 'image': './assets/img/partnerOnboarding/msSQL.jpg', 'value': 'sqlserver'},
    {'displayName': 'Aurora-MySQL', 'image': './assets/img/partnerOnboarding/aurora.png', 'value': 'aurora-mysql'},
    {'displayName': 'CosmosDB', 'image': './assets/img/partnerOnboarding/cosmosDB.png', 'value': 'cosmos'},
    {'displayName': 'AuroraDB-PostgreSQL', 'image': './assets/img/partnerOnboarding/aurora.png', 'value': 'aurora-postgresql'},
    // {'displayName': 'Snowflake', 'image': './assets/img/partnerOnboarding/snowflake.png', 'value': 'snowflake'},
    // { 'displayName': 'I want to use my Database', 'value': 'private' }
  ];

  constructor() { }

  ngOnInit() {
    for (let i = 0; i < this.databaseTypes.length; i++) {
        if (this.databaseTypes[i]['value'] === this.databaseSelected) {
          const id = 'selectedDB' + i;
          this.availableDatabase.push(id);
        }
    }

    const that = this;
    $(document).ready(function () {
      for (const id of that.availableDatabase) {
        $('#' + id).css('border', '2px solid #ff672d');
      }
    });
  }

  selectDB(index) {
    this.databaseSelected = this.databaseTypes[index]['value'];
    this.selectedDatabaseOutput.emit(this.databaseSelected);
    for (let i = 0; i < this.databaseTypes.length; i++) {
      const id = 'selectedDB' + i;
      if (index === i) {
        $('#' + id).css('border', '2px solid #ff672d');
      } else {
        $('#' + id).css('border', 'transparent');
      }
    }
  }
}
